var card_content_default = {
  "content": "ewnJL",
  "textStart": "_2Qfbd",
  "contentText": "Xba3f",
  "subtitle": "o538P",
  "pricing": "rjgk-",
  "titlePriceContainer": "QwxMJ",
  "textCenter": "tpTTI",
  "textEnd": "IEtUj",
  "titlePriceSideBySide": "QQbB6",
  "titlePriceStacked": "q3HPV",
  "title": "X8Erg",
  "price": "zS9I9",
  "priceDiscounted": "Hy5A0",
  "priceOriginal": "dry0x",
  "priceStrikethrough": "_7vdVY",
  "ribbon": "nfaSn",
  "button": "_0pqqH",
  "button_disabled": "NXh7b",
  "buttonText": "GpLOt",
  "framelessContent": "gbAbJ",
  "framelessImageTop": "mqbIr",
  "framelessImageStart": "xyO2j",
  "framelessImageEnd": "V-P3B"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
